import React, { useState } from 'react'

import { Button, Form, Page } from '@fielded/shared-ui'
import { Arrow, Truck } from '@fielded/shared-ui/src/icons'

import PickUpContentsTable from '../component/PickUpContentsTable/PickUpContentsTable'
import ConfirmPickupModal from './ConfirmPickupModal'

const ConfirmPickUp = ({
  signatureFormRef,
  history,
  config,
  deliveries,
  driverName,
  onProceed,
  isAdjusted,
  withAdjustmentsFeature
}) => {
  const [modalVisible, setModalVisibility] = useState(false)

  const onTryProceed = async () => {
    const formValidationErrors = await signatureFormRef.current.validate()
    if (!formValidationErrors) {
      setModalVisibility(true)
    }
  }

  const onCloseVerificationModal = () => {
    setModalVisibility(false)
  }

  return (
    <Page className='shipments'>
      <Page.HeaderNew
        history={history}
        icon={<Truck />}
        subtitle="Warehouse manager's handover summary"
        title='Deliveries'
      />
      {isAdjusted && (
        <Page.Panel>
          <Page.Panel.Message
            fullWidth
            type='warning'
            title='Quantities updated'
            inline
          >
            Product quantities have been adjusted.
          </Page.Panel.Message>
        </Page.Panel>
      )}
      <Page.Panel withBackground>
        <Page.Panel.Section fullWidth>
          <PickUpContentsTable
            shipments={deliveries}
            withAdjustmentsFeature={withAdjustmentsFeature}
          />
        </Page.Panel.Section>

        <Page.Panel.Section className='confirm-pick-up__form-wrapper' fullWidth>
          <Form ref={signatureFormRef}>
            <Form.Section>
              <Form.Row>
                <Form.Field
                  labelText='Please sign below as the warehouse manager to confirm that all products have been handed over to the driver.'
                  fieldName='signature'
                  spread
                >
                  <Form.Field.Signature
                    defaultValue=''
                    required='Please sign'
                  />
                  <Form.Field.ValidationErrors />
                </Form.Field>
              </Form.Row>
            </Form.Section>
          </Form>
        </Page.Panel.Section>
      </Page.Panel>

      <Page.Footer layout='centered'>
        <Button
          fill='full'
          size='large'
          colorVariant='confirmation'
          iconSide='right'
          icon={<Arrow direction='right' />}
          onClick={() => onTryProceed()}
        >
          Proceed
        </Button>
      </Page.Footer>
      <ConfirmPickupModal
        isOpen={modalVisible}
        onClose={onCloseVerificationModal}
        onConfirm={onProceed}
      />
    </Page>
  )
}

export default ConfirmPickUp
